import React from 'react';
import PropTypes from 'prop-types';
import styles from './Products.module.sass';
import { numberToCurrency } from '../../../../checkout/services/utils';
import ProductButton from '../../../../products/components/product_button/ProductButton';

function Products(props) {
  const { products, addToBag } = props;

  const addToBagClickHandler = (product, eventId) => {
    const { id, variantId } = product;
    addToBag({ id, variantId, eventId });
  };

  const productPrice = (product) => {
    if (product.variants.length === 0) {
      return product.price;
    }

    return product.variants.sort(
      (variantA, variantB) => (Number(variantA.price) < Number(variantB.price) ? 1 : -1),
    )[0].price;
  };

  return (
    <div className={styles.products}>
      {products.map((product, index) => (
        <div className={styles['product-block']} key={product.id}>
          <div className={styles.step}>
            {`Step ${index + 1}`}
          </div>
          <div className={styles.category}>
            {product.regimenCategory}
          </div>
          <div className={styles['product-wrapper']}>
            <div className={styles.line} />
            <div className={styles.product}>
              <div className={styles.image}>
                <a href={product.url}>
                  <img src={product.image} alt={product.name} />
                </a>
              </div>
              <div className={styles.column}>
                <div className={styles.title}>
                  <a href={product.url}>
                    {product.name}
                  </a>
                </div>
                <div className={styles['short-description']}>
                  {product.shortDescription}
                </div>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: product.description }}
                />
                <div className={styles['desktop-row']}>
                  <div className={styles.price}>
                    {numberToCurrency(productPrice(product))}
                    {' '}
                    USD
                  </div>
                  <div className={styles.variant}>
                    {product.variant}
                  </div>
                </div>
                <div className={styles['add-to-bag-wrapper']}>
                  <ProductButton
                    waitlistSubscribable={product.waitlistSubscribable}
                    subscribed={product.subscribed}
                    available={product.available}
                    showAddToBag={product.showAddToBag}
                    redirectionEnabled={product.redirectionEnabled}
                    redirectText={product.redirectText}
                    redirectLink={product.redirectLink}
                    limitation={product.limitation}
                    loading={product.loading}
                    productUrl={product.url}
                    addToBagClickHandler={(eventId) => { addToBagClickHandler(product, eventId); }}
                    price={parseFloat(product.price)}
                    discount={parseFloat(product.discount) || 0}
                    productId={product.id}
                    sku={product.sku}
                    name={product.name}
                    variant={product.variant}
                    buttonColor="transparent-green"
                    image={product.image}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

Products.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string.isRequired })).isRequired,
  addToBag: PropTypes.func.isRequired,
};

export default Products;
